module.exports = __webpack_public_path__ + "img/muliply_icon.1187e4ea.png";